import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.scss'],
})
export class GaugeComponent implements OnInit {
  @Input() indexes =[1,2,3,4,5];
  @Input() title = 'Speed';
  @Input() average;
  @Input() max;
  @Input() angle= 128;
  @Input() unit;
  @Input() maxAngle;

  constructor() { }

  ngOnInit() {}

}
